<div *ngIf="value.length == 0">
    <div class="row m-b-xs">
        <div class="dv-label col-sm-3 strong" style="font-size: 13px;">{{title}}</div>

        <div class="dv-value col-sm-9">
            <i *ngIf="!noEdit" (click)="addEmptyUse()" class="fa icon-plus pull-right" data-toggle="tooltip"
               data-placement="top" title="Add"></i>
        </div>
    </div>
</div>

<div *ngIf="!isEditMode">
    <div (dblclick)="editModeOn()" class="row m-b-xs" *ngFor="let val of value; let index = index;">
        <div class="dv-label col-sm-3 strong" style="font-size: 13px;">{{index > 0 ? '' : title}}</div>

        <div class="dv-value col-sm-9" style="min-height: 31px;">
            <span>{{val}}</span>
            <i *ngIf="!noEdit" (click)="removeUse(index)" class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top"
               title="Delete"></i>
            <i *ngIf="!noEdit" (click)="editModeOn()" class="fa fa-pencil pull-right" data-toggle="tooltip" data-placement="top"
               title="Edit"></i>
        </div>
    </div>
</div>

<div *ngIf="isEditMode">
    <div class="row m-b-xs" *ngFor="let val of value; let index = index; trackBy: trackByFn">
        <div class="dv-label col-sm-3 strong" style="font-size: 13px;">
            {{index > 0 ? '' : title}}
        </div>

        <div class="dv-value-edit col-sm-9" [class.hidden]="!isEditMode">
            <input class="form-control"
                   [(ngModel)]="value[index]"
                   maxlength="255"
                   (keyup.enter)="apply()">

            <button *ngIf="!editOnly" type="button" (click)="apply()"><i class="fa fa-check"></i></button>
            <button type="button" (click)="cancel()"><i class="fa fa-times"></i></button>
        </div>
    </div>
</div>
<div *ngIf="value.length > 0" class="row m-b-xs">
    <div class="col-sm-12">
        <i *ngIf="!noEdit" (click)="addEmptyUse()" class="fa icon-plus pull-right" data-toggle="tooltip"
           data-placement="top" title="Add"></i>
        <div *ngIf="noEdit" style="min-height: 20px;"></div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/settings-amenity-uses-field/settings-amenity-uses-field.component.html